import { render, staticRenderFns } from "./DocName.vue?vue&type=template&id=9a1b1b5a&scoped=true&lang=pug"
import script from "./DocName.vue?vue&type=script&lang=js"
export * from "./DocName.vue?vue&type=script&lang=js"
import style0 from "./DocName.vue?vue&type=style&index=0&id=9a1b1b5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1b1b5a",
  null
  
)

export default component.exports